import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Button } from "./ui/button";
import { LogOut, User, LayoutDashboard, Car } from "lucide-react";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem,
  DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger,
} from "./ui/dropdown-menu";

export default function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  let dashLink = "/dashboard";
  if (user?.role === "admin") dashLink = "/admin";
  else if (user?.role === "vendor") dashLink = "/vendor";

  return (
    <nav className="sticky top-0 z-50 backdrop-blur-xl bg-[#050B14]/70 border-b border-white/10">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 h-16 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-2">
          <div className="w-8 h-8 rounded-lg bg-sky-400 flex items-center justify-center">
            <Car className="w-5 h-5 text-[#050B14]" strokeWidth={2.5} />
          </div>
          <span className="text-xl font-light tracking-tight text-white">Ride<span className="text-sky-400">Karoo</span></span>
        </Link>

        <div className="hidden md:flex items-center gap-8 text-sm text-slate-300">
          <Link to="/vehicles" data-testid="nav-vehicles" className="hover:text-white transition-colors">Browse Vehicles</Link>
          {user && user.role === "vendor" && (
            <Link to="/vendor" data-testid="nav-vendor-dash" className="hover:text-white transition-colors">Vendor</Link>
          )}
          {user && user.role === "admin" && (
            <Link to="/admin" data-testid="nav-admin-dash" className="hover:text-white transition-colors">Admin</Link>
          )}
        </div>

        <div className="flex items-center gap-3">
          {!user ? (
            <>
              <Button variant="ghost" onClick={() => navigate("/login")} data-testid="nav-login-btn"
                className="text-slate-300 hover:text-white hover:bg-white/5">Login</Button>
              <Button onClick={() => navigate("/register")} data-testid="nav-register-btn"
                className="bg-sky-400 text-[#050B14] hover:bg-sky-300 font-medium">Get Started</Button>
            </>
          ) : (
            <DropdownMenu>
              <DropdownMenuTrigger asChild>
                <button data-testid="nav-user-menu" className="flex items-center gap-2 px-3 py-2 rounded-lg border border-white/10 hover:bg-white/5 transition-colors">
                  <div className="w-7 h-7 rounded-full bg-sky-400/20 border border-sky-400/30 flex items-center justify-center">
                    <User className="w-4 h-4 text-sky-300" />
                  </div>
                  <span className="hidden sm:inline text-sm text-slate-200">{user.name}</span>
                </button>
              </DropdownMenuTrigger>
              <DropdownMenuContent align="end" className="bg-[#0A111A] border-white/10 text-slate-200">
                <DropdownMenuLabel className="text-slate-400 font-normal text-xs">
                  {user.email} · <span className="text-sky-300 capitalize">{user.role}</span>
                </DropdownMenuLabel>
                <DropdownMenuSeparator className="bg-white/10" />
                <DropdownMenuItem onClick={() => navigate(dashLink)} data-testid="menu-dashboard" className="cursor-pointer focus:bg-white/5">
                  <LayoutDashboard className="w-4 h-4 mr-2" /> Dashboard
                </DropdownMenuItem>
                <DropdownMenuItem onClick={async () => { await logout(); navigate("/"); }} data-testid="menu-logout" className="cursor-pointer focus:bg-white/5">
                  <LogOut className="w-4 h-4 mr-2" /> Sign out
                </DropdownMenuItem>
              </DropdownMenuContent>
            </DropdownMenu>
          )}
        </div>
      </div>
    </nav>
  );
}
